import { IInitialState } from 'store/models';
import { authStateSelector } from './authStateSelector';

export function roleSelector(state: IInitialState) {
	return authStateSelector(state).role;
}
